
import Breadcrumb from '@/components/Breadcrumb'
import WxFollowQr from '@/components/WxFollowQr'
import TitleBox from '@/components/CSS/TitleBoxOld'
import empowerDialog from '@/components/empowerDialog'
import ReleaseRulePhone from '@/components/ReleaseRulePhone'
import Upload from '@/components/Upload'
import { mapGetters } from 'vuex'
import { debounce } from '@/utils/validate'
import { openWxFollow } from '@/settings'
import { UPLOAD_COMMON_TYPE } from '@/enum/uploadType'
import { getTimeDifference } from '@/utils/index'
const BASE = 'BASE' // 基本信息
const ACCOUNT = 'ACCOUNT' // 账号信息
const SAFEGUARD = 'SAFEGUARD' // 保障信息

export default {
    components: {
        Breadcrumb,
        WxFollowQr,
        empowerDialog,
        TitleBox,
        Upload
    },
    computed: {
        ...mapGetters({
            userinfo: 'user/userinfo',
            goodsKey: 'game/goodsKey',
            releaseDataObj: 'game/releaseDataObj',
            releaseGoodsBreadcrumb: 'game/releaseGoodsBreadcrumb',
            exposureNum: 'game/exposureNum',
            config: 'config',
            editGoodsState: 'editGoodsState'
        }),
        // whetherShotType() {
        // 	return item => {
        // 		if (this.ruleForm.isXiaomiTransfer) {
        // 			return this.xmOptions
        // 		}
        // 		if (this.releaseGoodsBreadcrumb.gameName == '地下城与勇士手游' && this.releaseGoodsBreadcrumb.system !== 'QQ') {
        // 			this.ruleForm.shotType = 'ONESELF'
        // 			return [{ key: 'ONESELF', value: '自己上传' }]
        // 		} else {
        // 			return item.option
        // 		}
        // 	}
        // },
        showLoading() {
            if (this.goodsKeyByBase.length || this.goodsKeyByAccount.length || this.goodsKeyBySafeguard.length) {
                return false
            }
            return true
        },

        feeShow() {
            let feeResult = []
            let price = this.ruleForm.price
            this.getFeeData &&
                this.getFeeData.forEach(item => {
                    let fee = {
                        fee: 0,
                        name: item.feeTypeName
                    }
                    let targetFee = item.fees.find(feeItem => feeItem.priceMin <= price && feeItem.priceMax > price)
                    if (!targetFee) return

                    if (targetFee.feeWay === 'FIXED') {
                        fee.name += '(固定)'
                        fee.fee = targetFee.fee.toFixed(2)
                    } else {
                        fee.name += `(费率${targetFee.fee}%)`
                        fee.fee = (price * (targetFee.fee / 100)).toFixed(2)
                    }

                    if (Number(fee.fee) === 0) return
                    feeResult.push(fee)
                })
            let total = feeResult.reduce((total, item) => total + Number(item.fee), 0)
            return {
                show: !!feeResult.length,
                list: feeResult,
                total: (price - total).toFixed(2)
            }
        }
    },
    data() {
        const checkPrice = (rule, value, callback) => {
            if (!value) {

                callback(new Error('请输入价格'))
            }
            const reg = /^[1-9]\d*$/
            const val = value.toString()
            if (!reg.test(val)) {
                callback(new Error('请输入正确的价格'))
            } else {
                callback()
            }
        }
        return {
            realNameModelState: false,
            checkPrice,
            isResell: false,
            pricePattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
            buyType: '',
            openWxFollow,
            showSelectNumber: 10, // 如果单选框超过10个就显示下拉框
            descData: {
                desImage: null,
                title: null
            },
            chargeFee: null,
            reChargeFee: null,
            minReChargeFee: null,
            dialogQuestion: false,
            submitLoading: false,
            rules: {},
            ruleForm: {
                detailsCheckbox1: [],
                linkQq: null,
                linkPhone: null,
                linkWx: null,
                gameSecretRes: '',
                goodsNo: '',
                shotRemark: null,
                description: null,
                title: null,
                shotType: null, //截图方式
                sellMethod: null, //截图方式
                // detailsSingle5: null,
                isXiaomiTransfer: false,
                serviceType: null, //服务订单类型
                sellMessage: null, // 卖家留言
                inviteCode: null, // 推广码
            },
            configOptions: [],
            goodsKeyByBase: [], //基本信息
            goodsKeyByAccount: [], //账号信息
            goodsKeyBySafeguard: [], //保障信息
            getFeeData: null,
            enableConfidenceBuy: false, //是否开启放心购
            enableFastSell: false, //是否显示极速卖
            articleDetail: {}, //购买须知
            centerDialogVisible2: false, // 购买须知弹窗
            ruleUserPhone: false, // 验证手机号码
            xmOptions: [{ key: 'ONESELF', value: '自己上传' }],
            // lolDetailsSingle5: null,
            dataTime: ['', ''],
            UPLOAD_COMMON_TYPE,
            startTime: null,
            confidenceUserConfig: {}, //放心购用户配置
            releaseData: {},
            inviteInfo:{}
        }
    },
    async created() {
        //
        if (this.$route.query.buyType === 'RECOVERY') {
            this.buyType = 'RECOVERY'
        } else {
            this.buyType = ''
        }
        // this.$store.dispatch('AppGetOssAuth')
        // 编辑专用;
        this.ruleForm.goodsNo = this.$route.query.goodsNo || null
        this.releaseData = this.releaseDataObj[this.releaseDataObj.currentId] || {}

        // console.log(this.ruleForm, '********************')
        // 编辑;
        if (this.ruleForm.goodsNo) {
            await this.getDataKey()
            this.getReleaseDetails()
        } else {
            this.ruleForm.isXiaomiTransfer = /^(true|1)$/i.test(this.$route.query.isXiaomiTransfer)
            this.ruleForm.shotType = this.releaseData.shotType
            // 添加
            this.getListGoodsPropertyConfigOptions()
        }
        // 显示用户保障信息
        this.getUserLinkMessageHandler()
        if ((this.ruleForm.goodsCatalogueId == 7 || this.releaseData.goodsCatalogueId == 7) && !this.config && !this.config[this.$enum.CONFIG.config_10]) this.$store.dispatch('index/AppPublicConfig')

        if (!this.ruleForm.goodsNo) {
            // 获取服务费
            let data = {
                action: {
                    gameId: this.ruleForm.gameId || this.releaseData.gameId,
                    goodsCatalogueId: this.ruleForm.goodsCatalogueId || this.releaseData.goodsCatalogueId,
                    goodsNo: this.ruleForm.goodsNo
                }
            }
            this.$api.getFeeNew(data).then(res => {
                if (res.success) {
                    this.getFeeData = res.data
                }
            })
        }

        this.getIsBuyState()
    },
    mounted() {
        this.startTime = new Date().getTime()
        this.$store.dispatch('game/ExposureNum')
        this.getConfidenceUserConfig()

        if (this.$route.query.isResell) {
            this.isResell = true
        } else {
            this.isResell = false
        }
        this.$api.getActivityBenefitInviteCode({ gameId: this.$route.query.gameId || this.ruleForm.gameId || this.releaseData.gameId }).then(res => {
			if (res.success) {
				this.inviteInfo = res.data
			    // 将邀请码同步到表单数据中
				this.ruleForm.inviteCode = res.data.inviteCode || ''
	     	}
	    })
    },
    methods: {
        /**
         * 处理价格输入
         * @param value 输入的值
         * @param prop  要赋值的属性
         */
        handlePriceInput(value,prop) {
            if (!value) return
            value = value.replace(/\./g, '')
            this.$nextTick(() => {
                this.ruleForm[prop] = value
            })
        },
        /**
         * 获取放心购用户配置
         */
        async getConfidenceUserConfig() {
            const res = await this.$api.confidenceUserConfigAPI({ action: { gameId: this.$route.query.gameId || this.ruleForm.gameId || this.releaseData.gameId } })
            if (!res.success) return this.$message.error(res.info)
            this.confidenceUserConfig = res.data
        },
        validatePass(rule, value, callback) {
            if (value === '') {
                callback(new Error('请输入确认密码'))
            } else if (value !== this.ruleForm.gameSecret) {
                callback(new Error('两次输入密码不一致!'))
            } else {
                callback()
            }
        },
        validatePrice(rule, value, callback) {
            if (!value) {
                callback(new Error('请输入价格'))
            } else if (!/(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/.test(value)) {
                callback(new Error('请输入有效价格'))
            } else if (value >= 99999999) {
                callback(new Error('超过最大金额'))
            } else {
                callback()
            }
        },
        validateHanzi(rule, value, callback) {
            if (!value) {
                callback(new Error('请输入游戏账号'))
            } else if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback(new Error('游戏账号不能输入汉字'))
            } else {
                callback()
            }
        },
        validateHanziYD(rule, value, callback) {
            if (!value) {
                callback(new Error('请输入营地号'))
            } else if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback(new Error('营地号不能输入汉字'))
            } else {
                callback()
            }
        },


		// 推广码输入限制 - 与表单数据双向绑定
		handleInviteCodeInput(event) {
			const value = event
			// 只允许数字和字母，并限制8位
			const filteredValue = value.replace(/[^0-9a-zA-Z]/g, '').substring(0, 8)
			// 更新到表单数据中
			this.ruleForm.inviteCode = filteredValue
			// 更新输入框显示
			event = filteredValue
		},

		checkCode(){
	        if (!this.ruleForm.inviteCode) return
			this.$api.checkActivityBenefitInviteCode(this.ruleForm.inviteCode).then(res=>{
				if(!res.data){
					this.$message.error('推广码不存在或已过期！')
				}
			})
		},

		handleInviteCodeKeypress(event){
			const char = String.fromCharCode(event.which)
			// 如果不是数字或字母，阻止输入
			if (!/[0-9a-zA-Z]/.test(char)) {
				event.preventDefault()
			}
			// 如果已经达到8位，阻止继续输入
			if (this.ruleForm.inviteCode && this.ruleForm.inviteCode.length >= 8) {
				event.preventDefault()
			}
		},

        
        feeByPrice() {
            let price = parseFloat(this.ruleForm.price)
            if (price !== 0 && /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/.test(price)) {
                let p = {
                    action: {
                        goodsPrice: price,
                        goodsCatalogueId: this.ruleForm.goodsCatalogueId || this.releaseData.goodsCatalogueId,
                        gameId: this.ruleForm.gameId || this.releaseData.gameId,
                        goodsNo: this.ruleForm.goodsNo
                    }
                }
                setTimeout(() => {
                    if (this.buyType === 'RECOVERY') {
                        this.$api.getReChargeFee(p).then(res => {
                            this.reChargeFee = res.data.serviceFee
                            this.minReChargeFee = res.data.minPrice
                        })
                    } else {
                        this.$api.getFee(p).then(res => {
                            if (!res.success) {
                                this.$message.error(res.info)
                                return
                            }
                            this.chargeFee = res.data
                            this.chargeFee.income = (price - this.chargeFee.finalBenefits).toFixed(2)
                        })
                    }
                }, 100)
            } else {
                this.chargeFee = null
                this.reChargeFee = null
                this.chargeFeeNew = null
            }
        },
        onEmpowerDialogClose() {
            this.submitLoading = false
        },
        // 显示用户保障信息
        getUserLinkMessageHandler() {
            this.$api.getUserLinkMessage().then(res => {
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                const data = res.data
                this.ruleForm.linkPhone = data.linkPhone
                this.ruleForm.linkQq = data.linkQq
                this.ruleForm.linkWx = data.linkWx
                this.dataTime[0] = data.easyTradeStartTime
                this.dataTime[1] = data.easyTradeEndTime
            })
        },
        /**
         * 重新选择，如果是编辑就带goodsNo
         */
        reselectBtn() {
            if (!this.editGoodsState) {
                let p = {
                    gameId: this.ruleForm.gameId || this.releaseData.gameId,
                    goodsCatalogueId: this.ruleForm.goodsCatalogueId || this.releaseData.goodsCatalogueId,
                    gameName: this.ruleForm.gameIdName || this.releaseData.gameName
                }
                this.$store.commit('game/SET_RELEASE_DATA', p)
                // 返回选择区服并禁用重新选择游戏
                this.$router.push(`/selectServer?reselect=true`)
                return
            }
            if (this.ruleForm.goodsNo) {
                // 编辑时是否点击了重选按钮
                let p = {
                    gameId: this.ruleForm.gameId,
                    goodsCatalogueId: this.ruleForm.goodsCatalogueId,
                    gameName: this.ruleForm.gameIdName
                }
                this.$store.commit('game/SET_RELEASE_DATA', p)
                // 返回选择区服并禁用重新选择游戏
                // this.$router.push(`/selectServer?reselect=true`)
                this.$router.push(`/selectServer?goodsNo=${this.ruleForm.goodsNo}&reselect=true`)
                return
            }
            let p = {
                gameId: this.releaseData.gameId,
                goodsCatalogueId: this.releaseData.goodsCatalogueId,
                gameName: this.releaseData.gameName
            }
            this.$store.commit('game/SET_RELEASE_DATA', p)
            this.$store.commit('game/SET_RELEASE_BREADCRUMB', {})
            this.$router.go(-1)
        },
        // 疑问描述图片
        shoDialogQuestion(item) {
            console.log(item, '疑问描述图片')
            this.descData = {
                desImage: item.desImage,
                title: item.propertyName
            }
            this.dialogQuestion = true
        },
        yuanshenqidong(item) {
            this.descData = {
                desImage: 'https://oss.pzds.com/pc-ssr-im/ys_gbyz.jpg',
                title: '关闭手机验证'
            }
            this.dialogQuestion = true
        },
        releaseConfirm: debounce(function (p) {
            this.$confirm('请确保您填写的信息无误，是否立即发布？', '提示', {
                confirmButtonText: '发布',
                cancelButtonText: '取消',
                type: 'warning',
                confirmButtonClass: 'confirmButtonClass'
            })
                .then(() => {
                    // 新增时，调用通知
                    !this.ruleForm.goodsNo && this.$api.setSellerGuideGoodsAPI({ del: true })
                    this.saveData(p)
                })
                .catch(() => (this.submitLoading = false))
        }),
        saveData(p, state) {
            if (!this.isResell) {
                p.action.edit = this.editGoodsState
            } else {
                p.action.resell = true
                p.action.edit = false
            }

            console.log(p, '保存的数据');

            // "shotType": "PZDS_OFFICIAL",
            if (this.buyType === 'RECOVERY') {
                p.action.shotType = 'ONESELF'
                this.$api.saveReGoods(p).then(res => {
                    this.submitLoading = false
                    if (!res.success) {
                        this.$message.error(res.info)
                        return
                    }
                    this.$message.success(res.info)
                    // 重置表单数据
                    this.$refs.ruleForm.resetFields()
                    this.$router.replace(`/success?goodsNo=${res.data.goodsNo}&gameId=${p.action.gameId}&goodsCatalogueId=${p.action.goodsCatalogueId}&buyType=${this.buyType}`)
                    // 清空发布数据、发布面包屑
                    setTimeout(() => {
                        this.$store.commit('game/CLEAR_RELEASE_DATA', p.action.gameId)
                        this.$store.commit('game/SET_RELEASE_BREADCRUMB', {})
                    }, 300)
                })
                return
            }

            //单独处理昵称发布shotType 字段为null问题
            if (this.releaseData.goodsCatalogueId == 7) {
                p.action.shotType = 'ONESELF'
            }

            this.$api.saveGoods(p).then(res => {

                this.submitLoading = false
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                if(this.$route.query.from == 'RECOVERY'){
                    this.$trackEvent({
                        eventType: 'click',
                        trackParams: {
                            eventName: '回收-确认发布商品',
                            gameId: this.ruleForm.gameId || this.releaseData.gameId,
                            goodsNo: res.data.goodsNo
                        }
                    })
                }
                this.$api.setSellerGuideGoodsAPI({ del: true })
                // 发布时常埋点
                let timeData = {
                    duration: getTimeDifference(new Date().getTime(), this.startTime),
                    event: 'GOODS_PUBLISH_DURATION',
                    eventId: res.data.goodsNo
                }
                this.$api.commonsMonitorHit(timeData).then(res => { })

                p.action.goodsNo = res.data.goodsNo
                // 判断是否需要验证
                if (this.ruleForm.shotType == 'THIRD_SHOT') {
                    if (state) {
                        this.$refs.empowerDialogRef.userCenterGoodsCheck(p, true, 1)
                    } else {
                        this.$router.push({
                            path: '/account/sellerDetails',
                            query: {
                                staus: 'WAIT_PUBLISH',
                                goodsNo: p.action.goodsNo,
                                orderStatus: '待发布',
                                gameId: p.action.gameId,
                                goodsCatalogueId: p.action.goodsCatalogueId
                            }
                        })
                    }
                } else {
                    this.saveGoodsResetFields(p)
                }
                console.log(res.data)
            })
        },
        // 检查 游戏账号是否重复 黑号＞重复＞需要验证码
        async checkGameAccountRepeat(data) {
            const res = await this.$api.userCenterGoodsCheck(data)
            if (!res.success) {
                this.$message.error(res.info)
                this.submitLoading = false
                return false
            }
            const isRepeat = !res.data.pass
            const isOwnGoodsRepeat = res.data.sellerOwn
            const isPhoneCheck = !res.data.checkPhonePass
            if (isRepeat && isOwnGoodsRepeat) {
                // 提示账号重复 所发布账号存在待发布/待审核中的商品, 前往个人中心查看
                this.$confirm('所发布账号存在待发布/待审核中的商品, 前往个人中心查看', '发布账号重复', {
                    customClass: 'custom-sell-alert',
                    confirmButtonText: '去看看',
                    cancelButtonText: '取消',
                    confirmButtonClass: 'confirmButtonClass'
                })
                    .then(() => {
                        this.submitLoading = false
                        this.$router.push({
                            path: '/account/sellerList'
                        })
                    })
                    .catch(() => {
                        this.submitLoading = false
                    })
                return false
            }
            if (isRepeat && !isOwnGoodsRepeat) {
                // 提示账号重复 所发布账号已存盼之平台, 暂时无法继续发布, 请仔细检查账号所属区服是否正确
                this.$alert('所发布账号已存盼之平台, 暂时无法继续发布, 请仔细检查账号所属区服是否正确', '发布账号重复', {
                    customClass: 'custom-sell-alert',
                    confirmButtonText: '我知道了',
                    confirmButtonClass: 'confirmButtonClass',
                    showClose: false,
                    callback: () => {
                        this.submitLoading = false
                    }
                })
                return false
            }
            // 校验手机号码不通过
            if (isPhoneCheck && data.action.linkPhone) {
                this.$refs.releaseRulePhoneRef.open(data)
                return false
            } else {
                this.submitLoading = false
                return true
            }

        },
        releaseRulePhoneConfirm(p) {
            this.releaseConfirm(p)
        },
        // 提交
        async onSubmit() {
            await this.$store.dispatch('user/UserGetInfo') 
            if(!this.userinfo.isRealName) {
                this.realNameModelState = true
                return
            }
            this.$refs.ruleForm.validate(async valid => {
                if (valid) {
                    this.submitLoading = true
                    if (this.ruleForm.shotType === 'PZDS_OFFICIAL' || this.ruleForm.shotType == 'THIRD_SHOT') {
                        this.ruleForm.description = 'pzds upload img'
                        this.ruleForm.title = 'pzds upload img'
                    }
                    let action = {}
                    // 如果是编辑，gameId就不从vuex取，从编辑返回的数据取

                    if (this.ruleForm.goodsNo) {
                        if (this.$route.query.reselect) {
                            action = { ...this.releaseData, ...this.ruleForm }
                        } else {
                            action = { ...this.ruleForm }
                        }
                    } else {
                        action = { ...this.ruleForm, ...this.releaseData }
                    }

                    let p = {
                        action: action
                    }

                    // 若状态为待发布或者审核失败，不校验是否重复
                    // if (!this.ruleForm?.status || !['VERIFY_FAIL', 'WAIT_PUBLISH'].includes(this.ruleForm?.status)) {
                    const isCheckSuccess = await this.checkGameAccountRepeat(p)
                    if (!isCheckSuccess) return
                    // }
                    this.submitLoading = false

                    if (this.ruleForm.shotType == 'THIRD_SHOT') {
                        this.$refs.empowerDialogRef.userCenterGoodsCheck(p, true, 999)
                    } else {
                        this.releaseConfirm(p)
                    }
                } else {
                    //自动定位到错误的地方
                    setTimeout(() => {
                        let isError = document.getElementsByClassName('is-error')
                        isError[0]?.querySelector('input').focus()
                        if (this.ruleForm.shotType === 'ONESELF') {
                            let dom = this.$refs[isError[0].id]
                            if (dom) {
                                //如果是个数组
                                dom[0].$el.scrollIntoView({
                                    block: 'center', // 当前元素显示在视图区域中间
                                    behavior: 'auto' //滚动速度
                                })
                            }
                        }
                    }, 100)
                    this.submitLoading = false
                }
            })
        },
        // 发布成功清空表单跳转至结果页
        saveGoodsResetFields(p) {
            // 重置表单数据
            this.$refs.ruleForm.resetFields()
            this.$router.replace(`/success?goodsNo=${p.action.goodsNo}&gameId=${p.action.gameId}&goodsCatalogueId=${p.action.goodsCatalogueId}&buyType=${this.buyType}`)
            // 清空发布数据、发布面包屑
            setTimeout(() => {
                this.$store.commit('game/CLEAR_RELEASE_DATA', p.action.gameId)
                this.$store.commit('game/SET_RELEASE_BREADCRUMB', {})
            }, 300)
        },
        /**
         * 把radio、checkbox等选择性值push到keyData的option里面去
         */
        getListGoodsPropertyConfigOptions() {
            return new Promise(() => {
                let p = {
                    action: {
                        gameId: this.ruleForm.gameId || this.releaseData.gameId,
                        goodsCatalogueId: this.ruleForm.goodsCatalogueId || this.releaseData.goodsCatalogueId,
                        single1: this.releaseData.single1 || null,
                        single2: this.releaseData.single2 || null,
                        single3: this.releaseData.single3 || null
                    }
                }
                if (this.$route.query.buyType === 'RECOVERY') {
                    p.action.inRecovery = true
                    p.action.inSell = undefined
                } else {
                    p.action.inRecovery = undefined
                    p.action.inSell = true
                }
                this.$api.listGoodsPropertyConfigOptions(p).then(res => {
                    if (!res.success) {
                        this.$message.error(res.info)
                        return
                    }
                    this.configOptions = res.data
                    if (this.buyType === 'RECOVERY') {
                        this.configOptions.map(item => {
                            if (item.mappingField === 'shotType') {
                                item.options = [
                                    {
                                        key: 'ONESELF',
                                        value: '自己上传'
                                    }
                                ]
                            }
                        })
                    }
                    this.goodsKey.map(item => {
                        let itemOption = { ...item, option: [] }
                        res.data.map(option => {
                            if (item.mappingField === option.mappingField) {
                                itemOption.option = option.options
                            }
                        })
                        if (itemOption.fieldType === 'CHECKBOX') {
                            // 多选就要用$set赋进去
                            let key = itemOption.mappingField
                            this.$set(this.ruleForm, key, [])
                        }
                        if (itemOption.mappingField === 'shotType') {
                            // 截图方式默认选择第一个，只有是添加的时候才会 --- 新增判断是是否是小米
                            // if (!this.ruleForm.goodsNo) {
                            // 	this.ruleForm.shotType = this.ruleForm.isXiaomiTransfer ? this.xmOptions[0].key : itemOption.option[0].key
                            // }
                        }
                        if (itemOption.mappingField === 'sellMethod') {
                            if (!this.ruleForm.goodsNo) this.ruleForm.sellMethod = itemOption.option[0].key
                        }
                        switch (itemOption.fieldConfigType) {
                            case BASE:
                                this.goodsKeyByBase.push(itemOption)
                                break
                            case ACCOUNT:
                                this.goodsKeyByAccount.push(itemOption)
                                break
                            case SAFEGUARD:
                                this.goodsKeyBySafeguard.push(itemOption)
                                break
                        }
                    })
                })
            })
        },
        matchedData(res) {
            // 获取 goodsKey 中所有的 mappingField 值
            let mappingFields = this.goodsKey.map(item => item.mappingField);
            // 分离 res.data 中的键值对
            const matchedData = {}; // 匹配到的键值对
            mappingFields = [
                ...mappingFields,
                'gameId',
                'goodsCatalogueId'
            ]
            if (!this.$route.query.reselect) {
                mappingFields.push('simpleMessage')
            }
            // 遍历 res.data 的所有键
            Object.keys(res.data).forEach(key => {
                if (mappingFields.includes(key)) {
                    matchedData[key] = res.data[key];
                }
            });
            console.log('匹配到的数据:', matchedData);
            return matchedData
        },
        /**
         * 编辑时数据回显
         */
        isisResell(goodsNo) {
            return new Promise((resovel, reh) => {
                if (this.$route.query.isResell) {
                    this.$api.gameGoodsDetails({
                        orderNo: this.$route.query.orderNo
                    }).then(async res => {
                        res.data = this.matchedData(res)
                        resovel(res)
                    })

                } else {
                    this.$api.goodsGoodsDetails({
                        action: {
                            goodsNo: goodsNo
                        }
                    }).then(res => {
                        console.log(res, '这是啥res');
                        const status = res.data.status;
                        res.data = this.matchedData(res)
                        resovel({ ...res, status })

                    })
                }
            })
        },
        getReleaseDetails() {
            this.isisResell(this.ruleForm.goodsNo)
                .then(async res => {
                    if (!res.success) {
                        this.$message.error(res.info)
                        return
                    }
                    let data = res.data
                    console.log(data, '这是啥data1111');

                    // 如果在编辑时点击了重选就用用户自己选择的面包屑
                    if (!this.$route.query.reselect) {
                        let simpleMessageArr = data.simpleMessage.split('-')
                        // 面包屑数组转对象
                        this.$store.commit('game/SET_RELEASE_BREADCRUMB', {
                            ...simpleMessageArr
                        })
                    }
                    // 给确认密码赋值
                    if (data.gameSecret) {
                        this.ruleForm.gameSecretRes = data.gameSecret
                    }

                    // 解决自动触发表单验证的bug
                    // Object.assign(this.ruleForm,data)
                    if (res.status == 'ONESELF_DOWN_STAND') {
                        this.ruleForm = { ...this.ruleForm, ...data, gameAccount: '', gameSecret: '', gameSecretRes: '' }
                        // 获取服务费
                        let _data = {
                            action: {
                                gameId: data.gameId,
                                goodsCatalogueId: data.goodsCatalogueId,
                                goodsNo: this.$route.query.goodsNo
                            }
                        }
                        this.$api.getFeeNew(_data).then(resFee => {
                            if (resFee.success) {
                                this.getFeeData = resFee.data
                            }
                        })
                        let p = {
                            action: {
                                goodsNo: this.$route.query.goodsNo
                            }
                        }
                        this.$api.deleteGoods(p).then(res => { })
                    } else {
                        this.ruleForm = { ...this.ruleForm, ...data }
                        // 从路由取是否是小米区服
                        this.ruleForm.isXiaomiTransfer = /^(true|1)$/i.test(this.$route.query.isXiaomiTransfer)
                    }
                    // 重新选区服后不按详情的区服
                    this.ruleForm = { ...this.ruleForm, ...this.releaseData }
                    console.log(this.ruleForm, '重新选区服后不按详情的区服数据');

                    this.$store.commit('game/SET_RELEASE_DATA', { ...this.ruleForm })
                    this.getListGoodsPropertyConfigOptions()
                })
        },
        /**
         * 获取传给后台的key
         */
        getDataKey() {
            let p = {
                action: {
                    gameId: this.releaseData.gameId,
                    goodsCatalogueId: this.releaseData.goodsCatalogueId,
                    needWrite: true
                }
            }
            if (this.$route.query.buyType === 'RECOVERY') {
                p.action.inRecovery = true
                p.action.inSell = undefined
            } else {
                p.action.inRecovery = undefined
                p.action.inSell = true
            }
            return this.$store.dispatch('game/GoodsKey', p)
        },
        // 选择是否放心购
        buyConfidenceBuyFn() {
            this.ruleForm.serviceType = this.ruleForm.serviceType ? null : 'CONFIDENCE_BUY'
        },
        // 选择是否极速卖
        buyFastSellFn() {
            this.ruleForm.serviceType = this.ruleForm.serviceType ? null : 'FAST_SELL'
        },
        // 放心购是否开启
        getIsBuyState() {
            let data = {
                action: {
                    gameId: this.ruleForm.gameId || this.releaseData.gameId
                }
            }
            this.$api.userCenterGameConfig(data).then(res => {
                if (res.success) {
                    this.enableConfidenceBuy = res.data.enableConfidenceBuy
                    this.enableFastSell = res.data.enableFastSell
                    if (res.data.enableConfidenceBuy) {
                        this.ruleForm.serviceType = 'CONFIDENCE_BUY'
                    }
                }
            })
        },
        // 查看放心购须知
        getNotice() {
            let data = {
                action: {
                    id: 44
                }
            }
            this.$api.getHagglingDetail(data).then(res => {
                if (res.success) {
                    this.articleDetail = res.data
                    this.centerDialogVisible2 = true
                } else {
                    this.$message.error(res.info)
                }
            })
        },
        // 用户方便交易时间
        checkTime(val) {
            if (this.dataTime[0] && this.dataTime[1]) {
                let data = {
                    action: { easyTradeStartTime: this.dataTime[0], easyTradeEndTime: this.dataTime[1] }
                }
                this.$api.userTimeEdit(data).then(res => { })
            }
        }
    }
}
